// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"193":"8fcd09b0","5747":"ad70e22a","6245":"8fcd09b0"}[chunkId] + ".chunk.css";
};